export default __webpack_public_path__ + "static/media/carol.4bdddb5f.jpeg";